import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { useSession } from './useTenantContext';
const paths = new Set([
  '/customers',
  '/invoices',
  '/estimates',
  '/contracts',
  '/suppliers',
  '/expenses',
  '/reminders',
  '/depreciations',
  '/audit-log',
]);
const contexts = new Map<string, Record<string, unknown>>();
/** Keep explicit return links in the same tenant's last list/filter context. */
export function useListContext(backTo?: string) {
  const location = useLocation();
  const { data: session } = useSession();
  const scope = `${session?.user.id}:${session?.activeTenantId}`;
  useEffect(() => {
    if (session?.activeTenantId && paths.has(location.pathname))
      contexts.set(`${scope}:${location.pathname}`, location.search);
  }, [scope, session?.activeTenantId, location.pathname, location.search]);
  return backTo && paths.has(backTo) ? (contexts.get(`${scope}:${backTo}`) ?? {}) : {};
}
